// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import types
import { IHttpResponse } from 'app_types/httpTypes'
import { ICourseSchedulingModesHttpResponse, ICourseSchedulingModeHttpResponse } from 'app_types/admin/courseScheduling/courseSchedulingModeTypes'
// @end

class CourseSchedulingModeService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  async listExternal(params: any = {}) {
    this.refreshAuthToken()

    let responseData: ICourseSchedulingModesHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/course-scheduling-mode/external/`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  async list(params: any = {}) {
    this.refreshAuthToken()

    let responseData: ICourseSchedulingModesHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/course-scheduling-mode`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }


  insertOrUpdate = async (postData: any, action: string = 'create') => {
    this.refreshAuthToken()

    let responseData: ICourseSchedulingModeHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/course-scheduling-mode/${action}`,
      // headers: new Headers({
      //   Accept: 'application/json, application/xml, text/plain, text/html, *.*',
      //   'Content-Type': 'multipart/form-data',
      // }),
      auth_token: this.token,
      params: {...postData},
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.courseSchedulingMode
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  getOne = async (id: string) => {
    this.refreshAuthToken()

    let responseData: ICourseSchedulingModeHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/course-scheduling-mode/${id}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.courseSchedulingMode
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  remove = async (id: string) => {
    this.refreshAuthToken()

    let responseData: IHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'DELETE',
      url: `/api/admin/course-scheduling-mode/delete/${id}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return true
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }
}

export default CourseSchedulingModeService
